<template>
	<div
		v-shortkey="['ctrl', 'b']"
		class="d-none d-md-block globalSearch"
		@shortkey="focus()"
	>
		<a-auto-complete
			ref="select"
			v-model="value"
			option-label-prop="title"
			@search="search"
			@focus="search"
			@select="select"
		>
			<template slot="dataSource">
				<a-select-option
					v-for="item in data"
					:key="item._EntityId.toString()"
					:title="render(item)"
				>
					<div class="d-flex align-items-center">
						<fa-icon
							:icon="['far', 'bars']"
							class="mr-2"
						/>
						<span>{{ render(item) }}</span>
					</div>
				</a-select-option>
			</template>

			<a-input-search
				:value="value"
				placeholder="Buscar..."
				:loading="loading"
			/>
		</a-auto-complete>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
	name: 'GlobalSearch',
	data() {
		this.lastFetchId = 0;
		this.search = debounce(this.search, 300);
		return {
			data: [],
			value: '',
			fetching: false,
			loading: false
		};
	},
	computed: {
		limit() {
			return 5;
		},
		app() {
			return this.$settings.custom.globalSearch.app;
		},
		text() {
			return this.$settings.custom.globalSearch.text;
		}
	},
	methods: {
		search(value = '') {
			this.loading = true;

			const filters = this.$gestios.$utils.filter(this.app, value);

			this.$gestios.items(this.app).list({
				page: 1,
				limit: this.limit,
				filters
			}).then((result) => {
				this.data = result.data;
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});
		},
		select(e) {
			this.$settings.custom.globalSearch.onSelect(this.$router, e);
			setTimeout(() => { this.value = ''; }, 100);
		},
		focus() {
			const select = this.$refs.select;
			select.focus();
		},
		render(item) {
			if (Array.isArray(this.text)) {
				for (let i = 0; i < this.text.length; i += 1) {
					const f = this.text[i];
					if (item[f]) return item[f];
				}
			} else {
				return item[this.text] || '';
			}

			return '';
		}
	}
};
</script>

<style lang="scss">
	.globalSearch {
		max-width: 100%;

		.ant-select-selection{
			background-color: transparent !important;
		}

		.ant-input-search {
			input{
				border: 1px solid #373365;
			}

			.ant-input-suffix .ant-input-search-icon{
				color: #373365;
			}
		}
	}

	@media (max-width: $lg-min-width) {
		.globalSearch {
			.ant-input-search {
				width: 200px !important;
			}
		}
	}

	@media (min-width: $lg-min-width) {
		.globalSearch {
			.ant-input-search {
				width: 350px !important;
			}
		}
	}

</style>
